module.exports = __webpack_public_path__ + "img/MA-powered-Logo.458aea5b.svg";